export default {"src":"/_next/static/media/cool.e737deec.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};